import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Package, Repeat, Gift, Bell, MessageCircle, User } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const tabs = [
  { path: '/individual/dashboard',       label: 'Home',      icon: Home },
  { path: '/individual/orders',          label: 'Orders',    icon: Package },
  { path: '/individual/foldpass',        label: 'FoldPass',  icon: Repeat },
  { path: '/individual/referrals',       label: 'Refer',     icon: Gift },
  { path: '/individual/notifications',   label: 'Alerts',    icon: Bell },
  { path: '/individual/chat',            label: 'Support',   icon: MessageCircle },
  { path: '/individual/profile',         label: 'Profile',   icon: User },
];

const IndividualBottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem('individualToken');
    if (!token) return;
    const fetchUnread = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/individual/notifications/unread-count`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUnreadCount(res.data.count || 0);
      } catch { /* non-critical */ }
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 md:hidden">
      <div className="flex items-center justify-around h-14 w-full px-0">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = pathname === tab.path;
          return (
            <button key={tab.path} onClick={() => navigate(tab.path)}
              className={`relative flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${active ? 'text-blue-600' : 'text-slate-400'}`}>
              <div className="relative">
                <Icon className={`w-4 h-4 ${active ? 'stroke-[2.5]' : ''}`} />
                {tab.path === '/individual/notifications' && unreadCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-red-500 text-white text-[8px] font-bold rounded-full flex items-center justify-center">
                    {unreadCount > 9 ? '9+' : unreadCount}
                  </span>
                )}
              </div>
              <span className="text-[9px] font-medium leading-none">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default IndividualBottomNav;
